import NewsViewComponent from "../components/NewsView";
import useAllNews from "../hook/useAllNews";

const NewsView = () => {
    const useAllNewsList = useAllNews();

    return <NewsViewComponent {...useAllNewsList} />;
};

export default NewsView;
